import { makeStyles } from '@material-ui/core';

export const useTextAreaStyles = makeStyles(theme => ({
  root: {
    color    : theme.palette.text.main,
    outline  : 'none',
    '& label': {
      fontSize  : '14px',
      fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
      fontWeight: '400',
      lineHeight: '1.42857',
      opacity   : '1',
      color     : theme.palette.muiGrey.main,
    },
  },
}));
